import type { StoreFrontOptionsColumnLayoutDto } from '@b-stock/listing-api-client'

import type { ColumnLayoutIdEnum } from '../types'
import { getCustomLayoutColumnIds } from '../types'

/**
 * Which List View an event came from: the page it was on, and the column
 * arrangement that page rendered.
 */
export type ListViewSurface = {
  context: 'alp' | 'storefront'
  template: 'custom' | 'gen_merch' | 'mobile'
}

const SURFACE_BY_LAYOUT: Record<ColumnLayoutIdEnum, ListViewSurface> = {
  ALL_AUCTIONS_GEN_MERCH: { context: 'alp', template: 'gen_merch' },
  STOREFRONT_GEN_MERCH: { context: 'storefront', template: 'gen_merch' },
  STOREFRONT_MOBILE: { context: 'storefront', template: 'mobile' },
  STOREFRONT_MOBILE_ATT: { context: 'storefront', template: 'mobile' },
  STOREFRONT_MOBILE_T_MOBILE: { context: 'storefront', template: 'mobile' },
}

export const getListViewSurface = ({
  columnLayoutId,
  customColumnLayout,
}: {
  columnLayoutId?: ColumnLayoutIdEnum
  customColumnLayout?: StoreFrontOptionsColumnLayoutDto
}): ListViewSurface => {
  // If we have a custom layout with valid columns, it takes precedence.
  // Only storefronts can have custom layouts.
  if (getCustomLayoutColumnIds(customColumnLayout).length) {
    return { context: 'storefront', template: 'custom' }
  }

  const { context, template } =
    SURFACE_BY_LAYOUT[columnLayoutId ?? 'ALL_AUCTIONS_GEN_MERCH']

  return { context, template }
}
